import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

/**
 * منع الشاشة البيضاء الصامتة — بدل انهيار التطبيق كاملاً عند خطأ عرض،
 * نُظهر الخطأ ومكانه مع زر إعادة تحميل.
 * Catches render crashes so a broken page shows a readable error instead of a blank app.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('UI crash:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
          <div className="card max-w-2xl w-full">
            <h1 className="text-2xl font-bold text-danger-600 mb-4">
              Something went wrong
            </h1>
            <pre className="text-sm text-gray-700 dark:text-gray-200 whitespace-pre-wrap bg-gray-100 dark:bg-gray-800 rounded-xl p-4 mb-4 overflow-auto max-h-64">
              {this.state.error.message}
            </pre>
            {this.state.error.stack && (
              <pre className="text-xs text-gray-500 whitespace-pre-wrap bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 mb-4 overflow-auto max-h-48">
                {this.state.error.stack.split('\n').slice(0, 8).join('\n')}
              </pre>
            )}
            <button
              className="btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
